/* trekvoss Dachlast-Check (Kollektions-Modus) — Fahrzeug wählen, passende Dachzelte zuerst.
   Nutzt dieselbe Fahrzeug-DB wie das Produkt-Widget (trekvoss-dachlast-db.json)
   und die generierte Zeltliste (trekvoss-dachzelte-liste.json). */
(function () {
  'use strict';

  if (customElements.get('trekvoss-dachlast-kollektion')) return;

  var ICONS = {
    fit: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>',
    no:  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>'
  };

  function kg(n) { return String(Math.round(n * 10) / 10).replace('.', ',') + ' kg'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function bildUrl(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  class TrekvossDachlastKollektion extends HTMLElement {
    connectedCallback() {
      this.traeger = parseFloat(this.dataset.traegerGewicht || '4');
      this.reserveWarn = parseFloat(this.dataset.reserveWarn || '15');
      this.entries = [];
      this.zelte = [];

      var acc = this.querySelector('details.tvdk-acc');
      if (acc && window.matchMedia('(min-width: 700px)').matches) acc.open = true;
      if (acc) {
        var openByHash = function () {
          if (window.location.hash === '#dachlast-check') acc.open = true;
        };
        openByHash();
        window.addEventListener('hashchange', openByHash);
      }

      this.elBrand = this.querySelector('[data-dk-marke]');
      this.elModel = this.querySelector('[data-dk-modell]');
      this.elYear = this.querySelector('[data-dk-baujahr]');
      this.elResult = this.querySelector('[data-dk-result]');
      this.elHint = this.querySelector('[data-dk-hint]');

      var self = this;
      Promise.all([
        fetch(this.dataset.dbUrl).then(function (r) { if (!r.ok) throw new Error('DB HTTP ' + r.status); return r.json(); }),
        fetch(this.dataset.zelteUrl).then(function (r) { if (!r.ok) throw new Error('Zelte HTTP ' + r.status); return r.json(); })
      ]).then(function (res) {
        self.entries = res[0].fahrzeuge || [];
        self.zelte = res[1].zelte || [];
        self.fillBrands();
      }).catch(function (err) {
        var e = self.querySelector('[data-dk-error]');
        if (e) e.hidden = false;
        if (window.console) console.warn('Dachlast-Check (Kollektion): Daten nicht ladbar', err);
      });

      this.elBrand.addEventListener('change', function () { self.onBrand(); });
      this.elModel.addEventListener('change', function () { self.onModel(); });
      this.elYear.addEventListener('change', function () { self.render(); });
    }

    reset(sel) { sel.innerHTML = '<option value="">Wählen …</option>'; sel.disabled = true; }

    fill(sel, items, getValue, getLabel) {
      this.reset(sel);
      items.forEach(function (it, i) {
        var o = document.createElement('option');
        o.value = String(getValue(it, i));
        o.textContent = getLabel(it);
        sel.appendChild(o);
      });
      sel.disabled = false;
    }

    fillBrands() {
      var brands = [];
      this.entries.forEach(function (e) { if (brands.indexOf(e.marke) === -1) brands.push(e.marke); });
      brands.sort(function (a, b) { return a.localeCompare(b, 'de'); });
      this.fill(this.elBrand, brands, function (b) { return b; }, function (b) { return b; });
    }

    onBrand() {
      var brand = this.elBrand.value, models = [];
      this.entries.forEach(function (e) { if (e.marke === brand && models.indexOf(e.modell) === -1) models.push(e.modell); });
      models.sort(function (a, b) { return a.localeCompare(b, 'de'); });
      if (brand) this.fill(this.elModel, models, function (m) { return m; }, function (m) { return m; });
      else this.reset(this.elModel);
      this.reset(this.elYear);
      this.hideResult();
    }

    onModel() {
      var brand = this.elBrand.value, model = this.elModel.value, gens = [];
      this.entries.forEach(function (e, i) { if (e.marke === brand && e.modell === model) gens.push({ e: e, i: i }); });
      if (model) this.fill(this.elYear, gens, function (g) { return g.i; }, function (g) { return g.e.baujahr || 'alle Baujahre'; });
      else this.reset(this.elYear);
      this.hideResult();
    }

    hideResult() {
      this.elResult.hidden = true;
      this.elResult.innerHTML = '';
      if (this.elHint) {
        this.elHint.hidden = false;
        this.elHint.textContent = !this.elBrand.value ? 'Schritt 1 von 3 — wähle zuerst deine Marke.'
          : !this.elModel.value ? 'Schritt 2 von 3 — wähle dein Modell.'
          : 'Schritt 3 von 3 — wähle das Baujahr.';
      }
    }

    karte(z, v, status, zeile) {
      return '<a class="tvdk-card ' + status + '" href="' + esc(z.url) + '">'
        + (z.bild ? '<img loading="lazy" src="' + esc(bildUrl(z.bild, 360)) + '" alt="' + esc(z.titel) + '">' : '<span class="tvdk-noimg"></span>')
        + '<span class="tvdk-card-title">' + esc(z.titel) + '</span>'
        + '<span class="tvdk-card-meta">' + kg(z.gewicht_kg) + ' Zelt + ca. ' + kg(this.traeger) + ' Träger</span>'
        + '<span class="tvdk-chip ' + status + '">' + ICONS[status === 'no' ? 'no' : 'fit'] + '<span>' + zeile + '</span></span>'
        + '</a>';
    }

    render() {
      var idx = this.elYear.value;
      if (idx === '') { this.hideResult(); return; }
      var v = this.entries[parseInt(idx, 10)];
      if (!v) { this.hideResult(); return; }

      var self = this;
      var load = v.dachlast_dyn_kg;
      var fit = [], nofit = [];
      this.zelte.forEach(function (z) {
        var need = z.gewicht_kg + self.traeger;
        if (need <= load) fit.push(z); else nofit.push(z);
      });

      if (this.elHint) this.elHint.hidden = true;

      var name = v.marke + ' ' + v.modell + (v.baujahr ? ' (' + v.baujahr + ')' : '');
      var html = '';

      html += '<div class="tvdk-summary ' + (fit.length ? 'fit' : 'no') + '">'
        + '<strong>' + fit.length + ' von ' + this.zelte.length + ' Dachzelten</strong> passen auf deinen '
        + esc(name) + ' — dynamische Dachlast <strong>' + kg(load) + '</strong>, gerechnet inkl. ca. '
        + kg(this.traeger) + ' für Querträger.</div>';

      if (v.hinweis) html += '<div class="tvdk-vhinweis">' + esc(v.hinweis) + '</div>';

      if (fit.length) {
        html += '<div class="tvdk-grid">' + fit.map(function (z) {
          var reserve = load - (z.gewicht_kg + self.traeger);
          var knapp = reserve < self.reserveWarn;
          return self.karte(z, v, knapp ? 'knapp' : 'fit', knapp ? 'Passt knapp — ' + kg(reserve) + ' Reserve' : 'Passt · ' + kg(reserve) + ' Reserve');
        }).join('') + '</div>';
      } else {
        html += '<div class="tvdk-leer">Für diese Dachlast haben wir aktuell kein passendes Dachzelt im Sortiment. '
          + 'Prüfe die Angabe im Fahrzeughandbuch — oder <a href="mailto:info@trekvoss.com">melde dich</a>, wir beraten dich gern.</div>';
      }

      if (nofit.length) {
        html += '<details class="tvdk-nofit"><summary>' + nofit.length + ' Dachzelte sind für dein Fahrzeug zu schwer</summary>'
          + '<p class="tvdk-nofit-erklaerung">Zelt + Träger überschreiten die dynamische Dachlast deines Fahrzeugs. '
          + 'Die Dachlast gilt nur während der Fahrt — im Stand trägt das Dach deutlich mehr; entscheidend bleibt die Fahrt zur Übernachtung.</p>'
          + '<div class="tvdk-grid">' + nofit.map(function (z) {
            var ueber = (z.gewicht_kg + self.traeger) - load;
            return self.karte(z, v, 'no', 'Um ' + kg(ueber) + ' zu schwer');
          }).join('') + '</div></details>';
      }

      this.elResult.innerHTML = html;
      this.elResult.hidden = false;
    }
  }

  customElements.define('trekvoss-dachlast-kollektion', TrekvossDachlastKollektion);
})();
